import { Flex, FloraButton } from '@grupoboticario/flora-react';
import { DollarSignCircleIcon, PencilIcon } from '@grupoboticario/flora-react-icons';
import { RootState } from 'core';
import { useSelector } from 'react-redux';
import { ResponsiveFloraTypography } from 'ui/components/primitives';

import { paymentsNewFlow } from './const/summary.const';
import { PaymentStyles } from './Payment.styles';
import { SUMMARY_COMPONENTS_CONST, type PaymentProps } from './Summary.components.d';

const PaymentBase = ({
  changePaymentMethod,
  description = '',
  paymentPlans = [],
}: PaymentProps) => {
  const paymentOption = useSelector((state: RootState) => state.checkout.paymentOption);
  const isIncludedPaymentPlan = paymentsNewFlow.includes(paymentOption.paymentPlanType || '');
  return (
    <PaymentStyles.Component data-testid={SUMMARY_COMPONENTS_CONST.PAYMENT_TEST_ID}>
      <Flex direction="row" justify="space-between" align="center">
        <Flex direction="row" gap="$1">
          <DollarSignCircleIcon size={24} />
          <ResponsiveFloraTypography fontSize="bodyLargeStandard" fontWeight="medium">
            Forma de pagamento
          </ResponsiveFloraTypography>
        </Flex>
        <div>
          <FloraButton
            onClick={changePaymentMethod}
            hierarchy="tertiary"
            has="iconRight"
            icon={<PencilIcon size={24} />}
          >
            Editar
          </FloraButton>
        </div>
      </Flex>

      <PaymentStyles.Card>
        {paymentPlans.length > 0 && isIncludedPaymentPlan ? (
          <>
            {paymentPlans.map((plan, index) => (
              <div
                className={
                  index < paymentPlans.length - 1 ? 'item-payment' : 'item-payment without-border'
                }
                key={plan.name}
              >
                <ResponsiveFloraTypography
                  fontSize="bodyLargeStandard"
                  fontWeight="regular"
                  color="nonInteractivePredominant"
                >
                  {plan.name}
                </ResponsiveFloraTypography>
              </div>
            ))}
          </>
        ) : (
          <div className="item-payment without-border">
            <ResponsiveFloraTypography
              fontSize="bodyLargeStandard"
              fontWeight="regular"
              color="nonInteractivePredominant"
            >
              {description}
            </ResponsiveFloraTypography>
          </div>
        )}
      </PaymentStyles.Card>
    </PaymentStyles.Component>
  );
};

export default PaymentBase;
